import { useId } from 'react';
import { Checkbox } from '@noor/ui';
import { useTranslation } from 'react-i18next';

interface ReviewGateProps {
  confirmed: boolean;
  onChange: (confirmed: boolean) => void;
  label?: string | undefined;
}

/**
 * "All changed fields reviewed" gate (Figma 584:11839 footer) — approve
 * stays disabled until set. Ids are per instance, so several gates (one per
 * pending modifier group) can share a modal.
 */
export function ReviewGate({ confirmed, onChange, label }: ReviewGateProps) {
  const { t } = useTranslation('moderation');
  const id = useId();
  return (
    <label
      htmlFor={id}
      className="flex cursor-pointer items-center gap-1.5 text-sm leading-[1.4] font-normal text-form-label-fg select-none"
    >
      <Checkbox
        id={id}
        checked={confirmed}
        onCheckedChange={(value) => onChange(value === true)}
      />
      {label ?? t('detail.reviewConfirm', 'Проверено все измененные поля')}
    </label>
  );
}
